import { Component } from 'preact';
import handleLoadingAndError from '../handle-loading-and-error';
import { yearlyRainfallGraphFactory } from './graph-factory';
import PanelGraph from '../panelgraph';

class YearlyRainGraph extends Component {

	constructor(props, context) {
		super(props, context);
		this.factory = yearlyRainfallGraphFactory;
	}

	render(props) {
		const opts = {
			rainUnit: props.rainUnit,
			colors: props.colors,
			activeSeries: props.activeSeries
		};

		return <PanelGraph data={props.data}
		                   opts={opts}
		                   graphFactory={this.factory}
		                   mounted={this.props.mounted} />;
	}

}

export default handleLoadingAndError(YearlyRainGraph);



// WEBPACK FOOTER //
// ./components/yearly-rain-graph/index.js